<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "TransferReturns",
    data() {
        return {
            msg: 'Transfers Here',
        }
    },
}
</script>

<style scoped>

</style>
